import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@prcins/environments';

@Injectable({
  providedIn: 'root'
})
export class ContactInfoService {
  
  private baseUrl = environment.BASE_URL; // Adjust this to your actual API endpoint

  constructor(private http: HttpClient) { }

  getContactInfoFromServer(userId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/account/getContactInfo/${userId}`);
  }

  /**
   * Returns an observable with { shouldShow: boolean, contactInfo: any }
   * Handles all popup logic and provides contact info for pre-population.
   */
  getContactInfo(userId: string): Observable<{ shouldShow: boolean, contactInfo: any }> {
    return new Observable(observer => {
      this.getContactInfoFromServer(userId).subscribe(
        (data) => {
          const contactInfo = data || {};
          const phoneNumber = contactInfo.phoneNumber;
          const email = contactInfo.email;
          //const doNotShowAgain = contactInfo.doNotShowAgain;
          let shouldShow = true;
          if (phoneNumber && email) {
            shouldShow = false;
          } else if ((!phoneNumber || !email)) {
            shouldShow = true;
          }
          observer.next({ shouldShow, contactInfo });
          observer.complete();
        },
        () => {
          observer.next({ shouldShow: true, contactInfo: {} });
          observer.complete();
        }
      );
    });
  }

  updateContactInfo(userId: string, contactInfo: any): Observable<any> {
    // contactInfo should contain: email, phoneNumber, mobileIndicator, doNotShowAgain
    return this.http.post(`${this.baseUrl}/account/updateContactInfo/${userId}`, contactInfo);
  }

}
